import { Component, Input, OnInit } from '@angular/core';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import { ProductDetailTagsService } from '@product-detail/services/product-detail-tags.service';
import { TagProduct } from '@shared/components/usf-product-tag-list/models/tag-product.model';

@Component({
  selector: 'app-product-comparison-product-attributes',
  templateUrl: 'product-comparison-product-attributes.component.html',
  styleUrls: ['./product-comparison-product-attributes.component.scss'],
})
export class ProductComparisonProductAttributesComponent implements OnInit {
  @Input() productDetails: ProductDetailViewModel;
  @Input() isGuestUser: boolean;
  productTags: TagProduct[] = [];
  constructor(private productDetailTagsService: ProductDetailTagsService) {}

  ngOnInit(): void {
    if (this.productDetails) {
      this.productTags = this.productDetailTagsService.getDisplayTags(
        this.productDetails?.summary,
        this.productDetails.inventory,
        this.productDetails?.contract,
        this.productDetails?.customerPill,
        this.productDetails?.recentPurchase,
        this.productDetails?.trackingAttributes,
        this.productDetails?.resultRank,
        true,
        this.isGuestUser,
      );
    }
  }
}
